"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalBigVideoCategoryNews(t0) {
  const $ = _c(63);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "BUSINESS",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const category = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0BAA\u0BC6\u0BB0\u0BC1\u0BA8\u0B95\u0BB0\u0BBF\u0BB2\u0BCD \u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB \u0B9A\u0BB0\u0BCD\u0BB5\u0BA4\u0BC7\u0B9A \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAE\u0BA3\u0BBF: \u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD \u0BA4\u0BCA\u0B9F\u0B95\u0BCD\u0B95\u0BAE\u0BCD",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const title = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "\u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0BAA\u0BC6\u0BB0\u0BC1\u0BA8\u0B95\u0BB0\u0BBF\u0BB2\u0BCD \u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB \u0B9A\u0BB0\u0BCD\u0BB5\u0BA4\u0BC7\u0B9A \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAE\u0BA3\u0BBF \u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA4\u0BB2\u0BCD \u0B85\u0BB1\u0BBF\u0BAE\u0BC1\u0B95\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BAA\u0BCD\u0BAA\u0B9F \u0B89\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1.",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const excerpt = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: "Wed, 17 May 2023",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const timeAgo = t9;
  let t10;
  if ($[8] !== t5) {
    t10 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[8] = t5;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const imageSrc = t10;
  const router = useRouter();
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  let t11;
  if ($[10] !== imageSrc?.value) {
    t11 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const imageSrcValue = t11;
  const categoryValue = category?.value || "";
  const t12 = timeAgo?.value;
  let t13;
  if ($[12] !== t12) {
    t13 = getTimeAgo(t12);
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const timeAgoValue = t13;
  let t14;
  if ($[14] !== router || $[15] !== sectionUrl) {
    t14 = e => {
      if (sectionUrl) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrl);
      }
    };
    $[14] = router;
    $[15] = sectionUrl;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const handleCategoryClick = t14;
  let t15;
  if ($[17] !== imageMetadata || $[18] !== imageSrc?.customClass || $[19] !== imageSrc?.hidden || $[20] !== imageSrcValue || $[21] !== titleValue) {
    t15 = !imageSrc?.hidden && <div className={`flex-shrink-0 ${imageSrc?.customClass || ""}`}><div className="relative w-[106px] h-[76px] md:w-[150px] md:h-[110px] lg:w-[180px] lg:h-[130px] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100px, 300px" className="object-cover" style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[17] = imageMetadata;
    $[18] = imageSrc?.customClass;
    $[19] = imageSrc?.hidden;
    $[20] = imageSrcValue;
    $[21] = titleValue;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== category?.customClass || $[24] !== category?.hidden || $[25] !== categoryValue || $[26] !== handleCategoryClick || $[27] !== sectionUrl) {
    t16 = !category?.hidden && <>{sectionUrl ? <span className={`text-11-tamil-600 text-FFFFFF tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <div className={`text-11-tamil-600 text-FFFFFF tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>}</>;
    $[23] = category?.customClass;
    $[24] = category?.hidden;
    $[25] = categoryValue;
    $[26] = handleCategoryClick;
    $[27] = sectionUrl;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== title?.customClass || $[30] !== title?.hidden || $[31] !== titleValue) {
    t17 = !title?.hidden && <h3 className={`text-14-tamil-700 text-FFFFFF leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[29] = title?.customClass;
    $[30] = title?.hidden;
    $[31] = titleValue;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== excerpt?.customClass || $[34] !== excerpt?.hidden || $[35] !== excerptValue) {
    t18 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-FFFFFF leading-[1.3] line-clamp-2 opacity-70 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[33] = excerpt?.customClass;
    $[34] = excerpt?.hidden;
    $[35] = excerptValue;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t17 || $[39] !== t18) {
    t19 = <div className="flex flex-col gap-1 md:gap-2">{t16}{t17}{t18}</div>;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== timeAgo?.customClass || $[42] !== timeAgo?.hidden || $[43] !== timeAgoValue) {
    t20 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-FFFFFF ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[41] = timeAgo?.customClass;
    $[42] = timeAgo?.hidden;
    $[43] = timeAgoValue;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const t21 = slug ? `/${slug}` : undefined;
  let t22;
  if ($[45] !== excerptValue || $[46] !== imageSrcValue || $[47] !== slug || $[48] !== t21 || $[49] !== titleValue) {
    t22 = <MessageIcon id="small-image-news-vert-message-icon" variant="message-icon-4" slug={slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t21} />;
    $[45] = excerptValue;
    $[46] = imageSrcValue;
    $[47] = slug;
    $[48] = t21;
    $[49] = titleValue;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t20 || $[52] !== t22) {
    t23 = <div className="flex items-center justify-between text-FFFFFF">{t20}{t22}</div>;
    $[51] = t20;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t19 || $[55] !== t23) {
    t24 = <div className="flex flex-col justify-between gap-2 w-full">{t19}{t23}</div>;
    $[54] = t19;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t15 || $[58] !== t24) {
    t25 = <article className="bg-transparent text-FFFFFF p-4 mb-0 align-center"><div className="flex gap-4">{t15}{t24}</div></article>;
    $[57] = t15;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  const content = t25;
  if (slug) {
    const t26 = `/${slug}`;
    let t27;
    if ($[60] !== content || $[61] !== t26) {
      t27 = <Link href={t26} className="block hover:opacity-90 transition-opacity cursor-pointer">{content}</Link>;
      $[60] = content;
      $[61] = t26;
      $[62] = t27;
    } else {
      t27 = $[62];
    }
    return t27;
  }
  return content;
}